module.exports = __webpack_public_path__ + "static/WEDDING E&M-203-a8cc39d0211e479a2c8fd464cd564eae.jpg";